'use client'

import { useTranslations } from 'next-intl'
import { useFormState } from 'react-hook-form'

import { GetValueByPath } from '../../utils'

import { FormFieldError } from '../styled'

type TProps = {
    fieldName: string
    label: string
}

const ErrorRow = ({ fieldName, label }: TProps) => {
    'use no memo'
    const t = useTranslations('form')

    // Subscribes to this field's errors only (the old useFormErrors hook JSON-serialised all form
    // errors in every ErrorRow on every render).
    const { errors } = useFormState({ name: fieldName })

    const getErrorMessage = () => {
        const error: any = GetValueByPath(errors as Record<string, any>, fieldName as any)
        if (!error)
            return ''

        const message = error.message?.toString()
        if (!message || message == '') {
            if (error.type == 'required')
                return t('required-field', { label: label })

            return t('unknown-error')
        }

        return message
    }

    return <FormFieldError>{getErrorMessage()}</FormFieldError>
}

export default ErrorRow
